

const sources = [
    // 360.cn
    '360.cn',
    // Alice
    'www.alice.com',
    'aliceadsl',
    // Alltheweb
    'www.alltheweb.com',
    // Altavista
    'www.altavista.com',
    // AOL
    'www.aol.com',
    // Ask
    'www.ask.com',
    'search.aol',
    'alicesuche.aol.de',
    // Auone
    'search.auone',
    // Avg
    'isearch.avg.com',
    // Babylon
    'search.babylon.com',
    // Baidu
    'www.baidu.com',
    // Biglobe
    'biglobe.ne.jp',
    // Bing and all related properties
    'bing',
    // Centrum
    'search.centrum.cz',
    // Comcast
    'search.comcast.net',
    // Conduit
    'search.conduit.com',
    // CNN
    'www.cnn.com',
    // Daum
    'www.daum.net',
    // Dog Pile - From GD Source Tracking Plugin
    'dogpile.com',
    // DuckDuckGo
    'duckduckgo.com',
    // Ecosia
    'www.ecosia.org',
    // Ekolay
    'www.ekolay.net',
    // Eniro
    'www.eniro.se',
    // Globo
    'www.globo.com',
    // Go.mail.ru
    'go.mail.ru',
    // all google search domains
    'google',
    // Goo.ne
    'goo.ne.jp',
    // Hausou.com
    'www.haosou.com',
    // Incredimail
    'search.incredimail.com',
    // Kvasir
    'www.kvasir.no',
    // Live - already covered under 'bing'
    // Lycos + regional
    'www.lycos.com',
    'search.lycos',
    'www.mamma.com',
    // MSN + all related properties / subdomains
    'msn.com',
    // MyNet
    'www.mynet.com',
    // Najdi
    'najdi.si',
    // Naver
    'www.naver.com',
    // Netscape
    'search.netscape.com',
    // ONET
    'szukaj.onet.pl',
    // Ozu
    'www.ozu.es',
    // Rakuten
    'rakuten.co.jp',
    // Rambler
    'rambler.ru',
    // Search Results
    'search-results.com',
    // Search.smt.docomo
    'search.smt.docomo.ne.jp',
    // Sesam
    'sesam.no',
    // Sezname
    'www.seznam.cz',
    // So.com
    'www.so.com',
    // Sogou
    'www.sogou.com',
    // Startsiden
    'www.startsiden.no',
    // Szukacz
    'www.szukacz.pl',
    // Terra
    'buscador.terra.com.br',
    // Tut.by
    'search.tut.by',
    // Ukr
    'search.ukr.net',
    // Virgilio
    'search.virgilio.it',
    // Voila
    'www.voi,la.fr',
    // Wirtulana Polska
    'www.wp.pl',
    // YAHOO
    'yahoo.cn',
    'yahoo.com',
    // YANDEX
    'www.yandex.com',
    // YAM
    'www.yam.com',
];


export default class OrganicChannel {

    public static is(referrer: string) : boolean {
        for (let i = 0; i < sources.length; i ++) {
            if (referrer.indexOf(sources[i]) !== -1) {
                return true;
            }
        }
        return false;
    }

}
